import React, { useEffect, useRef, useState } from "react";

const OverallPortfolioCard = (props) => {
  const infoForm = useRef(null);
  const [overallSummaryData, setOverallSummaryData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [loanPaymentMode, setLoanPaymentMode] = useState(null);

  // OVERALL PORTFOLIO
  const getAdminDashboardOverall = (query, params) => {
    let data = {
      ...query,
      timeline: params || timeline || "ALL_TIME",
      ...(loanPaymentMode ? { paymentMode: loanPaymentMode } : { paymentMode: "ALL" }),
    };

    props.apis.apiGetAdminDashboardOverall(data).then((res) => {
      let overallData = res?.overall || {};
      setOverallSummaryData({
        overallBookCount: overallData?.disbursement?.count,
        overallBookAmount: overallData?.disbursement?.amount,
        activeCount: overallData?.active?.count,
        activeAmount: overallData?.active?.amount,
        closedCount: overallData?.closed?.count,
        closedAmount: overallData?.closed?.amount,
        overdueCount: overallData?.overdue?.count,
        overdueAmount: overallData?.overdue?.amount,
      })
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    console.log("value", value);
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "column-startDate",
      "column-endDate",
      "column-search_btn",
      "column-reset_btn",
    ];
    if (val === "CUSTOM") {
      showInputs(inputs);
      setOverallSummaryData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };
  const handlePaymentModeChange = (value) => {
    let val = value[0]?.key || "";
    if (val === "ALL") {
      setLoanPaymentMode(null);
    } else {
      setLoanPaymentMode(val);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    getAdminDashboardOverall(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "column-startDate",
      "column-endDate",
      "column-search_btn",
      "column-reset_btn",
    ];
    hideInputs(inputs);
    getAdminDashboardOverall({}, "TODAY");
  };

  useEffect(() => {
    getAdminDashboardOverall({}, timeline);
  }, [timeline, loanPaymentMode]);

  props.$setNode({
    props,
    overallSummaryData,
  });

  return (
    <>
      <div className="metrics_card_container mb-4">
        <div className="leads_detail_select_box">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-paymentmode"
            >
              <AppInputFocus
                type="select"
                name="paymentMode"
                label="Product Type"
                options={_enum.REPAYMENT_TYPES}
                onChange={(...args) => handlePaymentModeChange(...args)}
                placeholder="Product Type"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="column-startDate"
            >
              <AppInputFocus
                type="date"
                name="startDate"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="column-endDate"
            >
              <AppInputFocus
                type="date"
                name="endDate"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="column-search_btn"
            >
              <button type="submit" className="btn search_btn white_variant">
                <i className="fa fa-search"></i>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="column-reset_btn"
            >
              <button
                type="button"
                className="btn search_btn white_variant"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row g-4 metrics_card_row">
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overallBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Overall Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>
                    {overallSummaryData?.overallBookCount || 0}
                  </span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.overallBookAmount?.cur() ||
                      0}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCheckImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Active Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>
                    {overallSummaryData?.activeCount || 0}
                  </span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.activeAmount?.cur() ||
                      0}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.dollarCloseImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Closed Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>
                    {overallSummaryData?.closedCount || 0}
                  </span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.closedAmount?.cur() ||
                      0}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-3 metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.overdueBookImg}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">Over Due Book</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">No. Of Applications :</span>
                  <span>
                    {overallSummaryData?.overdueCount ||
                      0}
                  </span>
                </p>
                <p className="card-text">
                  <span className="me-2">Amount :</span>
                  <span>
                    {overallSummaryData?.overdueAmount?.cur() ||
                      0}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(OverallPortfolioCard);
